import React from 'react';

interface CancelWithBorderIconProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
    stroke?: string;
}

export const CancelWithBorderIcon: React.FC<CancelWithBorderIconProps> = ({
    width = 45,
    height = 45,
    fill = 'none',
    stroke = 'white',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 45 45"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.5 39.375C31.8198 39.375 39.375 31.8198 39.375 22.5C39.375 13.1802 31.8198 5.625 22.5 5.625C13.1802 5.625 5.625 13.1802 5.625 22.5C5.625 31.8198 13.1802 39.375 22.5 39.375Z"
                stroke={stroke}
                strokeWidth="3"
            />
            <path d="M15 15L30 30" stroke={stroke} strokeWidth="3" />
            <path d="M30 15L15 30" stroke={stroke} strokeWidth="3" />
        </svg>
    );
};
